if (!customElements.get('sok-collection')) {
  class SokCollection extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.cards = [...this.grid.querySelectorAll('.sok-coll-card')];
      this.count = this.querySelector('[data-count]');
      this.filter = '';
      this.sort = 'featured';

      this.querySelectorAll('[data-filter]').forEach((button) =>
        button.addEventListener('click', () => {
          if (button.dataset.filter === this.filter) return;
          this.filter = button.dataset.filter;
          this.mark('[data-filter]', button, 'aria-selected');
          this.apply();
        })
      );
      this.querySelectorAll('[data-sort]').forEach((button) =>
        button.addEventListener('click', () => {
          if (button.dataset.sort === this.sort) return;
          this.sort = button.dataset.sort;
          this.mark('[data-sort]', button, 'aria-pressed');
          this.apply();
        })
      );
    }

    mark(selector, active, attr) {
      this.querySelectorAll(selector).forEach((b) => {
        b.classList.toggle('is-active', b === active);
        b.setAttribute(attr, String(b === active));
      });
    }

    apply() {
      clearTimeout(this.timer);
      this.grid.classList.add('is-fading');
      this.timer = setTimeout(() => {
        const shown = this.cards.filter((c) => !this.filter || c.dataset.tags.split(' ').includes(this.filter));
        const order = [...shown].sort((a, b) => {
          // Quote-only products (no price) always sort last.
          if (this.sort !== 'featured' && (a.dataset.price === '0') !== (b.dataset.price === '0')) {
            return a.dataset.price === '0' ? 1 : -1;
          }
          if (this.sort === 'price-asc') return a.dataset.price - b.dataset.price;
          if (this.sort === 'price-desc') return b.dataset.price - a.dataset.price;
          return a.dataset.index - b.dataset.index;
        });
        this.cards.forEach((c) => (c.hidden = !shown.includes(c)));
        // The banner is pinned to grid row 2 in CSS, so card order alone decides what sits around it.
        order.forEach((c) => this.grid.insertBefore(c, this.grid.querySelector('.sok-coll-banner')));
        const n = shown.length;
        this.count.textContent = (n === 1 ? this.dataset.countOne : this.dataset.countMany).replace('[count]', n);
        this.grid.classList.remove('is-fading');
      }, 220);
    }
  }

  customElements.define('sok-collection', SokCollection);
}
